import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export const PromotionDescriptionContent = ({ description, emptyText = '' }) => (
  <Box
    sx={{
      '& img': { maxWidth: '100%', height: 'auto' },
      '& p:first-of-type': { mt: 0 },
      '& p:last-of-type': { mb: 0 },
      overflowWrap: 'anywhere'
    }}
    dangerouslySetInnerHTML={{ __html: description || emptyText }}
  />
);

PromotionDescriptionContent.propTypes = {
  description: PropTypes.string,
  emptyText: PropTypes.string
};
